import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { InputHandler } from '../../../../../viewer/input-handler';
import { SubscriptionTopic } from '../../../../../viewer/messaging/pubsub';
import { OrthophotoComparisonTool } from '../../../../../viewer/tools/orthophoto-comparison-tool';
import { useSubscribe, useSubscribeCallback } from '../../../../hooks/use-subscribe';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { ToolIcon } from '../tool-icon';

const CompareOrthophotosToolIcon = () => {
  const { t } = useTranslation();
  const { skyview, activeTool } = React.useContext(SkyviewContext);

  const [isDisabled, setIsDisabled] = useState(!skyview.isOrthoViewActive());
  const isActive = useMemo(() => activeTool instanceof OrthophotoComparisonTool, [activeTool]);

  useSubscribe(SubscriptionTopic.OnSceneChangeStarted, (message) => {
    setIsDisabled(message.scene !== 'skyviewScene');
    if (InputHandler.instance.isOrthophotoComparisonToolActive()) {
      InputHandler.instance.setTool('select');
    }
  });

  // The SkyView scene's camera decides whether it's an ortho view
  useSubscribeCallback(SubscriptionTopic.OnCameraChanged, () => {
    const isOrthoView = skyview.isOrthoViewActive();
    setIsDisabled(!isOrthoView);
    if (!isOrthoView && InputHandler.instance.isOrthophotoComparisonToolActive()) {
      InputHandler.instance.setTool('select');
    }
  });

  return (
    <ToolIcon
      active={isActive}
      callback={() => {
        if (!InputHandler.instance.isOrthophotoComparisonToolActive()) {
          InputHandler.instance.setTool('orthophoto-comparison');
        }
      }}
      disabled={isDisabled}
      icon={['fal', 'images']}
      tooltip={{
        title: t('compareOrthophotos.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('compareOrthophotos.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    />
  );
};

export { CompareOrthophotosToolIcon };
